<template>
  <div class="mfa-code-input">
    <fieldset class="input-group" :class="{ 'all-filled': allFilled, 'has-error': internalErrorMessage && !userEdited }">
      <label for="codeInput" class="code-input--label">
        <slot name="lblCode"/>
      </label>
      <input
        v-for="(digit, index) in code"
        :key="index"
        name="codeInput"
        ref="inputs"
        v-model="code[index]"
        type="text"
        maxlength="1"
        inputmode="numeric"
        autocomplete="one-time-code"
        pattern="[0-9]*"
        class="otp-input"
        :aria-label="'Ziffer ' + (index + 1)"
        @input="handleInput($event, index)"
        @keydown.delete="handleDelete(index)"
        @keypress="allowOnlyNumbers"
        @paste="handlePaste"
        @focus="selectInput"
      />
    </fieldset>
    <div class="request-new-code">
      <span class="error-message" v-if="internalErrorMessage">{{ internalErrorMessage }}</span>
      <span v-else><slot name="txtNoCodeReceived"/></span>
      <button
        type="button"
        class="btn text"
        :disabled="isWaiting"
        @click="requestNewCode"
      >
        <slot name="txtResend"/>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

const codeLength = 6

export default {
  name: 'MfaCodeInput',
  props: {
    errorMessage: {
      type: String,
      default: ''
    },
    errorKey: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      code: Array(codeLength).fill(''),
      waitTime: 30,
      timer: null,
      isWaiting: false,
      internalErrorMessage: this.errorMessage,
      userEdited: false
    }
  },
  mounted () {
    this.startCountdown()
  },
  methods: {
    ...mapActions('mfa', ['initiateMfa']),

    async requestNewCode () {
      if (this.isWaiting) return

      try {
        await this.initiateMfa()
        this.startCountdown()
      } catch (error) {
        this.userEdited = false
        this.internalErrorMessage = error?.networkError?.result?.errors?.[0]?.message || 'Ein unbekannter Fehler ist aufgetreten.'
      }
    },

    startCountdown () {
      this.isWaiting = true
      this.waitTime = 30

      clearInterval(this.timer) // clear existing timer
      this.timer = setInterval(() => {
        this.waitTime--
        if (this.waitTime <= 0) {
          clearInterval(this.timer)
          this.isWaiting = false
        }
      }, 1000)
    },

    handleInput(event, index) {
      this.userEdited = true

      const rawValue = event.target.value.replace(/\D/g, '')
      const value = rawValue.charAt(0) // nur das erste Zeichen nehmen

      this.code[index] = value

      if (value) {
        this.$nextTick(() => {
          this.focusNext(index)
        })
      }
    },

    focusNext (index) {
      if (index < this.code.length - 1) {
        this.$refs.inputs[index + 1]?.focus()
      }
    },

    handleDelete (index) {
      if (!this.code[index] && index > 0) {
        this.$refs.inputs[index - 1]?.focus()
      }
    },

    handlePaste (event) {
      const pasteData = event.clipboardData.getData('text').slice(0, 6).replace(/\D/g, '')
      if (pasteData.length === 6) {
        this.code = pasteData.split('')
        this.$refs.inputs[5]?.focus()
      }
    },

    allowOnlyNumbers (event) {
      if (!/^\d$/.test(event.key)) {
        event.preventDefault()
      }
    },

    selectInput(event) {
      event.target.select()
    }
  },
  computed: {
    allFilled () {
      return this.code.every(digit => digit !== '')
    }
  },
  watch: {
    code: {
      deep: true,
      handler (newCode) {
        this.$emit('updated', newCode.join(''))
      }
    },
    errorKey () {
      this.internalErrorMessage = this.errorMessage
      this.userEdited = false
    }
  }
}
</script>
